export default {
  videoAd: null,
};
